import React from "react";
import BrandValue from "web/react/components/brand-value/brand-value";
import CategoryLinks, { GenericType } from "web/react/components/category-links/category-links";
import HomepageBreakoutBrands, {
    HomepageBreakoutBrandsProps,
} from "web/react/components/homepage-breakout-brands/homepage-breakout-brands";
import HomepageMostWantedRail, {
    HomepageMostWantedRailsProps,
} from "web/react/components/homepage-most-wanted-rail/homepage-most-wanted-rail";
import PromoSection, { PromoSectionProps } from "web/react/components/promo-section/promo-section";
import TopLysts, { TopLystsProps } from "web/react/components/top-lysts/top-lysts";
import TopProducts, { TopProductsProps } from "web/react/components/top-products/top-products";
import { BrandValueSerializer } from "web/types/serializers";
import styles from "./homepage-layout.css";

interface HomepageLayoutProps {
    layoutData: {
        homepage_popular_products: TopProductsProps;
        homepage_brand_values: BrandValueSerializer;
        homepage_featured_banners: TopLystsProps;
        homepage_breakout_brands: HomepageBreakoutBrandsProps;
        homepage_trends: HomepageMostWantedRailsProps;
        homepage_generic_types: GenericType[];
        homepage_promo_banner: PromoSectionProps;
    };
}

export function HomepageLayout({
    layoutData: {
        homepage_popular_products: popularProducts,
        homepage_brand_values: brandValues,
        homepage_featured_banners: featuredBanners,
        homepage_breakout_brands: breakoutBrands,
        homepage_trends: trends,
        homepage_generic_types: genericTypes,
        homepage_promo_banner: promoBanner,
    },
}: HomepageLayoutProps): JSX.Element {
    return (
        <div className={styles.homepageLayout}>
            {promoBanner && <PromoSection data={promoBanner} />}
            {popularProducts && (
                <TopProducts title={popularProducts.title} products={popularProducts.products} />
            )}
            {featuredBanners && <TopLysts {...featuredBanners} />}
            {breakoutBrands && <HomepageBreakoutBrands {...breakoutBrands} />}
            {brandValues && <BrandValue className={styles.homepageBrandValue} {...brandValues} />}
            {trends && <HomepageMostWantedRail {...trends} />}
            {genericTypes && (
                <CategoryLinks genericTypes={genericTypes} id="homepage-category-links-rail" />
            )}
        </div>
    );
}

export default HomepageLayout;
